import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'

const columns = [
  { title: 'Id', prop: 'id' },
  { title: 'Question', prop: 'question' }
]

const filters = [
  { name: 'Filter by question', prop: 'filters.question_ilike', type: 'text', enabled: true },
  { name: 'Show deleted', prop: 'with_deleted', type: 'bool', value: true, enabled: false }
]

const defaults = {
  order: [
    { column: 'question', direction: 'asc' }
  ]
}

const Questions = (props) => (
  <List
    title='Questions'
    apiPath='admin/questions'
    columns={columns}
    filters={filters}
    defaults={defaults}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
    buildMenuItems={menuItems}
  />
)

export default Questions
